export enum ControlledLineIconTypes {
  external = "external",
  pdf = "pdf",
}

export type ControlledLineTargetRef = (element: HTMLElement | SVGElement | null) => void;
